import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { toastContainerBottomPixels, toastContainerMaxWidthPixels, toastContainerMinWidthPixels, toastContainerPaddingBottomPixels, toastContainerPaddingLeftPixels, toastContainerPaddingRightPixels, toastContainerPaddingTopPixels, } from './constants';
var toastAnimationProps = {
    animationIterationCount: 1,
    animationDuration: '0.5s',
};
export var useToastContainerStyles = makeStyles({
    toastContainer: __assign(__assign(__assign(__assign({}, shorthands.borderRadius(tokens.borderRadiusMedium)), { boxShadow: tokens.shadow8 }), shorthands.padding(toastContainerPaddingTopPixels, toastContainerPaddingRightPixels, toastContainerPaddingBottomPixels, toastContainerPaddingLeftPixels)), { backgroundColor: tokens.colorNeutralBackgroundInverted, color: tokens.colorNeutralForegroundInverted, '@media screen and (min-width: 320px), (max-width: 1366px)': {
            minWidth: toastContainerMinWidthPixels,
        }, '@media screen and (min-width: 1367px)': {
            minWidth: toastContainerMaxWidthPixels,
        } }),
    toastContainerSlideUpIn: __assign(__assign({}, toastAnimationProps), { animationName: {
            from: {
                transform: 'translate3D(0,100%,0)',
                opacity: '0',
            },
            to: { opacity: '1', transform: 'translate3D(0,0,0)' },
        }, animationTimingFunction: 'ease-out' }),
    toastContainerSlideDownOut: __assign(__assign({}, toastAnimationProps), { animationName: {
            from: {
                transform: 'translate3D(0,0,0)',
                opacity: '1',
            },
            to: {
                transform: 'translate3D(0,-100%,0)',
                opacity: '0',
            },
        }, animationTimingFunction: 'ease-in' }),
    toastWrapper: __assign(__assign({ bottom: toastContainerBottomPixels, left: '50%', position: 'fixed', transform: 'translateX(-50%)' }, shorthands.overflow('clip')), { overflowClipMargin: '8px' }),
    toastWrapperAnimating: __assign(__assign({}, shorthands.borderRadius(0)), { boxShadow: 'none' }),
    toastWrapperStill: __assign(__assign({}, shorthands.borderRadius(tokens.borderRadiusMedium)), { boxShadow: tokens.shadow8 }),
});
//# sourceMappingURL=ToastContainerControl.styles.js.map